<template>
  <div class="payment-content">
    <h1>活性物质分离纯化服务</h1>
    <h4 style="font-size: 15px">(Active substance separation and purification services)</h4>
    <br/>
    <p style="font-size: 16px">
      自然界中生物体产生的天然产物已被用作药物已经有数千年。早在公元前二世纪使用青蒿植物来治疗疟疾。另外近代早期的微生物学导致了从微生物中发现了大量的药物，最著名的如亚历山大·弗莱明发现的青霉素。当前真菌仍然是治疗传染病药物的最大来源。与其他天然产物资源相比，真菌具有以下优势。首先，真菌种类繁多，已描述的真菌种类约有 120,000 种和510万种未知真菌。其次，真菌可以产生结构广泛和多样的次级代谢产物。最后大规模发酵可生产大量的真菌次生代谢产物。近年来基因组测序技术的快速发展和更多的生物合成基因簇的挖掘，加速发现了更多来自真菌的新化合物。真菌可以从土壤、水、空气、植物或其他生物体中分离出来。尤其，植物的内生真菌可以产生与其宿主相近的次级代谢产物。生物多样化的真菌库对学术研究和工业界至关重要。澳岚丁通过多年的努力建立了一个样品来自全球且具有高度生物多样性的真菌库以促进新药的发现。
    </p>
    <br/>
    <div class="trait">
      <h3>服务类型-里程碑付款</h3>
      <table class="custom-table">
        <tr>
          <th>分离化合物个数</th>
          <th>质量(mg)</th>
          <th>价格(元)</th>
          <th>周期</th>
        </tr>
        <tr>
          <td>1</td>
          <td>5-10</td>
          <td>100000</td>
          <td>3-6</td>
        </tr>
      </table>
      <br/>
      <p>备注：
        <br/>
        1.如客户需要活性物质分离纯化服务,需首先购买至少100克真菌粗提取物。 
        <br/>
        2.澳岚丁公司只负责帮助客户分离纯化活性物质,不负责分离组分的活性测试。
        <br/>
        3.当完成一个阶段的分离后， 澳岚丁将把分离得到的组分邮寄给客户，然后客户进行组分的活性测试。
        <br/>
        4.提供活性化合物的液相色谱、质谱图谱和核磁图谱(C谱和H谱)数据以及分子结构鉴定报告书。
        <br/>
        5.付款方式:里程碑付款,客户首先付25%的预付款,当得到纯化的活性化合物后(≥90% 纯度),再付60%。结构鉴定后，再付余款(15%)。
      </p>
    </div>
    <div class="trait">
      <h3>服务类型-按阶段付款</h3>
      <table class="custom-table">
        <tr>
          <th>项目</th>
          <th>分离方法</th>
          <th>价格(元)</th>
          <th>周期</th>
        </tr>
        <tr>
          <td>分离阶段1</td>
          <td>提供分离方法和各组分的质量</td>
          <td>8000</td>
          <td>2-3周</td>
        </tr>
        <tr>
          <td>分离阶段2</td>
          <td>提供分离方法和各组分的质量</td>
          <td>8000</td>
          <td>2-3周</td>
        </tr>
        <tr>
          <td>分离阶段3</td>
          <td>提供分离方法和各组分的质量</td>
          <td>8000</td>
          <td>2-3周</td>
        </tr>
        <tr>
          <td>分离阶段4</td>
          <td>提供分离方法和各组分的质量</td>
          <td>8000</td>
          <td>2-3周</td>
        </tr>
        <tr>
          <td>液相、质谱和核磁全谱+结构解析</td>
          <td>液相色谱、质谱图谱和核磁(C谱和H谱)的数据</td>
          <td>10000</td>
          <td>2-3周</td>
        </tr>
      </table>
      <p>备注：
        <br/>
        1.按照分离阶段来收费。 
        <br/>
        2.当完成一个阶段的分离后， 澳岚丁将把分离得到的组分邮寄给客户，然后客户进行组分的活性测试。
        <br/>
        3.大部分的活性化合物需要四个阶段就可以分离得到高纯度（90%以上）的活性物质单体。两个阶段，我们将评定分离的难易程度通知用户。如实际分离需超过四个阶段，说明活性物质产量低，易失活，难分离。总收费不超过10万元人民币。
        <br/>
        4.提供活性化合物的液相色谱、质谱图谱和核磁图谱（C谱和H谱）数据以及分子结构鉴定报告书。
        <br/>
        5.优惠价：以1为基数，每增加10倍用户，价格减半。就是说：1-9个用户是表6给的价格。10-99个用户: 价格减半为每段4000元；100-999个用户:价格再减半为每段2000元，等等。如实际分离需超过四个阶段，价格以同样幅度优惠。
      </p>
    </div>
  </div>
</template>

<script>
import { recordDetailInfo } from '../../../request/request';

    export default {
      mounted(){
        recordDetailInfo('技术服务-分离纯化服务');
      },
      data () {
        return {
          value2: 0,
          advantage: [
            {
              img: 'static/image/game1.png',
              tit: '快速安装接入',
              con: 'quickly',
              info:'客户端安装便捷，SDK一键出包，后台简便部署，快速高效解决游戏接入和部署问题'
            },
            {
              img: 'static/image/game2.png',
              tit: '数据安全无忧',
              con: 'security',
              info:'无第三方介入用户登录、支付流程、用户运营数据传输皆在公司内部更安全'
            },
            {
              img: 'static/image/game3.png',
              tit: '多维数据管理',
              con: 'dimensional analysis',
              info:'强大的后台管理系统，多游戏管理，参数维护，数据统计分析，让游戏运营轻松可靠'
            }
          ],
          Packing: [
            {
              tit: '用户管理',
              con: '用户自建平台，满足个性化定制需求',
              btn:'敬请期待',
              href:''
            },
            {
              tit: '支付体系',
              con: '公司内部的支付流程，数据传播更安全，沟通无障碍',
              btn:'了解更多>',
              href:'payment'
            },
            {
              tit: '数据平台',
              con: '强大的后台管理功能，多游戏管理，参数维护，数据统计分析，财务报表，让游戏运营轻松可靠',
              btn:'了解更多>',
              href:'dataSystem'
            }
          ]
        }
      },
      methods: {
        goPage(id){
            if(id){
              this.$router.push({
                path:'/product',
                query: {
                  id: id
                }
              });
            }
          }
      }
    }
</script>

<style scoped lang="less">

.custom-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 16px;
}
.custom-table th, .custom-table td {
  border: 1px solid black;
  padding: 0px;
  text-align: center;
}
.custom-table th {
  background-color: #2596dc;
  color: white;
}

 .game-content{
   margin-left: -1px;
   .background{
     margin-bottom:64px;
     p{
       color: #7b8799;
     }
   }
   .advantage{
     margin-bottom:70px;
     .el-card{
       border:0;
     }
     .card{
       background: #fbfcfd;
       text-align: center;
       margin-top: 20px;
       img{
         margin: 40px auto 25px;
         width: 80px;
         height: 80px;
       }
       h4{
         color: #1f2d3d;
         font-weight: 400;
         margin: 0;
       }
       span{
         font-size: 14px;
         color: #99a9bf;
       }
     }
   }
   ul{
     margin-bottom: 50px;
     padding-left: 0;
     li{
       font-size: 14px;
       margin-bottom: 10px;
       color: #99a9bf;
     }
     li strong{
       font-weight: 400;
       color: #5e6d82;
     }
   }
   .Packing{
     h3{
       margin: 20px 0 40px 0;
       font-size: 22px;
     }
     .pack-card{
       h4{
         font-size: 18px;
       }
        p{
          color: #b7c1d2;
        }
        a{
          color:#409EFF;
          position: absolute;
          left: 20px;
          bottom: 15px;
        }
     }
   }
   .access{
     h3{
       margin: 65px 0 40px 0;
       font-size: 22px;
     }
   }
 }

</style>



// WEBPACK FOOTER //
// src/components/content/solution/game.vue